// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchFilters-cls1_9Xf","cls2":"SearchFilters-cls2_mO9 SearchFilters-cls1_9Xf"};